import { useContext } from "react";
import { createPortal } from "react-dom";
import { FiCheck } from "components/icons/FiCheck";
import { PendingCount } from "types/Models/Filing";
import { TaskHeaderSlotContext } from "./TaskHeaderSlotContext";

const ReadyForReview = () => (
  <span className="t-flex t-items-center t-gap-1.5 t-whitespace-nowrap t-rounded-full t-bg-white t-px-3 t-py-1 t-text-body-sm t-text-neutral">
    <span className="t-flex t-h-4 t-w-4 t-shrink-0 t-items-center t-justify-center">
      <FiCheck />
    </span>
    Ready for review
  </span>
);

/**
 * "5 of 20 pending" in the task header, or "Ready for review" once nothing is
 * pending; rendered from inside the filing form
 */
export const FormPendingCount = ({ pending, total }: PendingCount) => {
  const headerSlot = useContext(TaskHeaderSlotContext);

  if (!headerSlot || total === 0) {
    return null;
  }

  if (pending === 0) {
    return createPortal(<ReadyForReview />, headerSlot);
  }

  return createPortal(
    <span className="t-whitespace-nowrap t-px-3 t-py-1 t-text-body-sm t-text-neutral-70">
      {pending} of {total} pending
    </span>,
    headerSlot
  );
};
